const React = require('react');
const ReactDOM = require('react-dom');
const SnappRouter = require('./js/components/Router/Router.react');
require('./less/index.less');

ReactDOM.render(SnappRouter, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/app.js